import { useGate, useUnit } from 'effector-react'
import {
  $tickets,
  getTicketsFx,
  TicketListGate,
} from './model'

export const useTicketsList = () => {
  const tickets = useUnit($tickets)
  const loading = useUnit(getTicketsFx.pending)

  return { tickets, loading }
}
export const useTicketsListGate = () => useGate(TicketListGate)
